import { Enquiry } from '@/models/enquiry';

export class State {
    public myEnquiries: Array<Enquiry> = new Array<Enquiry>();
    public myEnquiriesPageNumber: number = 1;
    public myEnquiriesPageSize: number = 25;
    public myEnquiriesTotalPages: number = 1;
    public myEnquiriesTotal: number = 0;
    public myEnquiriesKeyword: string | null = null;
    public myEnquiriesFilterStatus: number | string | null = '';
    public myEnquiriesFrom: string | null = null;
    public myEnquiriesTo: string | null = null;

    public allEnquiries: Array<Enquiry> = new Array<Enquiry>();
    public allEnquiriesPageNumber: number = 1;
    public allEnquiriesPageSize: number = 25;
    public allEnquiriesTotalPages: number = 1;
    public allEnquiriesTotal: number = 0;
    public allEnquiriesKeyword: string | null = null;
    public allEnquiriesFilterStatus: number | string | null = '';
    public allEnquiriesFrom: string | null = null;
    public allEnquiriesTo: string | null = null;
}
